import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';
var ClaimService = /** @class */ (function () {
    function ClaimService(httpClient) {
        this.httpClient = httpClient;
    }
    ClaimService.prototype.setHomeHubValues = function (values) {
        (function (t, w, d, polizaIframe) {
            if (values && values.poliza) {
                w.poliza = values.poliza;
                if (polizaIframe) {
                    polizaIframe['contentWindow'].poliza = values.poliza;
                }
            }
        })(this, window, document, document.querySelector('#polizaIframe'));
    };
    ClaimService.prototype.check = function () {
        return this.httpClient.get(environment.server.api.claim + '/pas/link').pipe(map(mapResponseWithData));
    };
    ClaimService.prototype.sendMsg = function (w, values) {
        if (w) {
            w.postMessage(values, '*');
        }
    };
    return ClaimService;
}());
export { ClaimService };
